import { render } from "./channelAnalysis.vue?vue&type=template&id=2436f4e1&scoped=true"
import script from "./channelAnalysis.vue?vue&type=script&lang=js"
export * from "./channelAnalysis.vue?vue&type=script&lang=js"

import "./channelAnalysis.vue?vue&type=style&index=0&id=2436f4e1&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2436f4e1"],['__file',"src/views/data/components/channelAnalysis.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2436f4e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2436f4e1', __exports__)) {
    console.log('reload')
    api.reload('2436f4e1', __exports__)
  }
  
  module.hot.accept("./channelAnalysis.vue?vue&type=template&id=2436f4e1&scoped=true", () => {
    console.log('re-render')
    api.rerender('2436f4e1', render)
  })

}


export default __exports__